import React from "react";
import { Link } from "react-router-dom";

const MasonryLayoutV2 = ({ title, subtitle, items = [] }) => {
  return (
    <section className="flat-spacing-12 pb_0">
      <div className="container">
        {(title || subtitle) && (
          <div
            className="flat-title title-upper wow fadeInUp"
            data-wow-delay="0s"
          >
            {title && <span className="title fw-8 font-poppins">{title}</span>}
            {subtitle && (
              <p className="sub-title font-poppins text_black-2">{subtitle}</p>
            )}
          </div>
        )}
        <div className="masonry-layout-v2">
          {items.map((item, index) => {
            // Use offer_id if available, otherwise use the provided link
            const itemLink = item.id
              ? `/shop/default?offer_id=${item.id}`
              : item.link || "/shop/collection";

            return (
              <div
                key={index}
                className={`item-${
                  index + 1
                } collection-item-v5 hover-img wow fadeInUp`}
                data-wow-delay="0s"
              >
                <Link to={itemLink} className="collection-inner">
                  <div className="collection-image img-style">
                    <img
                      className="lazyload"
                      data-src={item.image}
                      src={item.image}
                      alt={item.alt || "collection-img"}
                    />
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default MasonryLayoutV2;
